import { ImageJSON } from '@/store/models/image';
import httpClient from '../http-client';
import { RequestConfig } from '../types';

export function file(data: FormData, config?: RequestConfig) {
  return httpClient.post<ImageJSON>('upload/file', data, config);
}
